import type { Doc } from "building-types/doc";
import { useUserContext } from "lib/state/UserContextProvider";
import { hasExportPermissionForTemplate } from "lib/utils/planDocumentPermissions";

/**
 * Filters plan set templates based on permissions
 * 1. Show all if hasPermission to download_home_plans
 * 2. Otherwise, filter by exportPermissions assigned to a role for each template in Studio
 */
export default function useFilteredPlanSetTemplatesForExport(
  planSetTemplates: Doc["planSetTemplates"],
  userId?: string,
  homePlanSalesAgentId?: string | null,
  locationSalesAgentId?: string | null,
) {
  const { enabledFeatures, hasPermission, builderUser } = useUserContext();
  if (!enabledFeatures.userDefinedPlansets) {
    return [];
  }
  if (!planSetTemplates) {
    return [];
  }
  if (hasPermission("DOWNLOAD_PLAN_SETS")) {
    return Object.values(planSetTemplates);
  }
  const isAssignedSalesAgent = !!(userId && (userId === homePlanSalesAgentId || userId === locationSalesAgentId));
  return Object.values(planSetTemplates).filter((t) =>
    hasExportPermissionForTemplate(t, builderUser?.roles, isAssignedSalesAgent),
  );
}
